/**
 * Created by vaibhav on 2/4/18
 */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', ...this.state }),
    })
      .then(() => alert('Your message has been sent.'))
      .catch(error => alert(error));

    e.preventDefault();
  };

  render() {
    return (
      <div>
        <section className="hero is-primary is-bold">
          <div className="hero-body">
            <div className="container">
              <div className="columns">
                <div className="column is-10 is-offset-2">
                  <div className="section" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="body section is-paddingless">
          <div className="container">
            <div className="section">
              <div className="columns">
                <div className="column is-12 is-offset-2 slide-up">
                  <div className="content column is-4">
                    <h2>Contact Us</h2>
                    <form
                      name="contact"
                      method="post"
                      action="/thanks/"
                      data-netlify="true"
                      data-netlify-honeypot="bot-field"
                      onSubmit={this.handleSubmit}
                    >
                      <p hidden>
                        <label class="label">
                          Don’t fill this out: <input name="bot-field" />
                        </label>
                      </p>

                      <div class="field">
                        <label class="label">Name</label>
                        <div class="control">
                          <input
                            class="input is-radiusless is-shadowless"
                            type="text"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>

                      <label class="label">Email</label>
                      <div class="control">
                        <input
                          class="input is-radiusless is-shadowless"
                          type="email"
                          name="email"
                          onChange={this.handleChange}
                        />
                      </div>

                      <div class="field">
                        <label class="label">Message</label>
                        <div class="control">
                          <textarea
                            name="message"
                            class="textarea is-radiusless is-shadowless"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>

                      <button type="submit" class="button is-link">
                        Send
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/templates/contact-page.js